export enum PaysafeFormField {
  Address = 'address',
  AccountName = 'accountName',
  BillingAddress = 'billingAddress',
  CardNumber = 'cardNumber',
  Cvv = 'cvv',
  ExpiryDate = 'expiryDate',
  MonthlyRenewal = 'monthlyRenewal',
  PaperlessPreference = 'paperlessPreference',
  TermsAndConditions = 'termsAndConditions',
}
